import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppService, CoreTypes, IncidentTypes, LabelValue, Modal } from 'common-cloudstudio';
import { IncidentFormComponent } from '../../incident-form/incident-form.component';
import { AssociateIncidentsComponent } from '../associate-incidents/associate-incidents.component';
import { IncidentFileComponent } from '../../incident-file/incident-file.component';

@Component({
  selector: 'app-incident-management-modal',
  templateUrl: './incident-management-modal.component.html',
  styleUrls: ['./incident-management-modal.component.scss']
})
export class IncidentManagementModalComponent implements OnInit {
  @ViewChild('modal') private _modal: Modal;
  @ViewChild('incidentForm') public _incidentForm: IncidentFormComponent;
  @ViewChild('incidentFileForm') public _incidentFileForm: IncidentFileComponent;
  @ViewChild('communicationForm') public _communicationForm: IncidentFormComponent;
  @ViewChild('associateIncident') public _associateIncident: AssociateIncidentsComponent;


  @Input() incidentID: number = 0;
  private _data: IncidentTypes.IncidentElementModal;
  @Input() set data(value: any) {
    this._data = value;
    this.parameters = JSON.parse(JSON.stringify(value));
    this.onChangeData(value);
  }

  get data(): IncidentTypes.IncidentElementModal {
    return this._data;
  }
  @Output() onClose = new EventEmitter<boolean>();

  public parameters: IncidentTypes.IncidentElementModal;
  private closeBySave = false;

  modalTitle: string = '';
  menuButtonList: LabelValue<number>[] = [{ label:  'Guardar y cerrar', value: 2 },];
  incidentManagementTypes = IncidentTypes.IncidentManagementType;
  _errorMessage: string = "";
  modalOpen: boolean = false;
  activeTab: number = 1;
  isOpen: boolean = false;
  disabledForm: boolean = false;
  modalVisible: boolean = false;

  constructor(
    public _appService: AppService,
    private cdRef:ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    
  }

  async open(args?: any) {
    this.modalVisible = true;
    this._errorMessage = "";
    setTimeout(() => this._modal.open(args), 100);
    setTimeout(() => this._modal.modalRoot.nativeElement.querySelector('label')?.focus(), 300);
    this.isOpen = true;
    this.closeBySave = false;
    if(this.parameters.IncidentElementTypeID === this.incidentManagementTypes.Incidents) {
      this._incidentForm?.setInitData(this.parameters.IncidentID);
    }
  }

  onChangeData(event) {

  }

  onCloseModal() {
    this.activeTab = 1;
    this.modalVisible = false;
    if (!this.closeBySave) { this.onClose.emit(true); }
    this.disabledForm = false;
    if(this.parameters.IncidentElementTypeID ===  this.incidentManagementTypes.Incidents) {
      this._incidentForm?.cleanForm();
      setTimeout(() => {
        if(this._incidentForm) {
          this._incidentForm.incidentData =  new CoreTypes.ITS_Incident();
          this._incidentForm.incidentData.Incident =  new CoreTypes.SimpleIncident();
        }
      }, 200);
    }
    if(this.parameters.IncidentElementTypeID ===  this.incidentManagementTypes.AssociateIncident) {
      this._associateIncident?.cleanSelectedIncident();
    }
  }

  onCloseForm() {
    if(this.parameters.IncidentElementTypeID ===  this.incidentManagementTypes.Incidents) {
      this._incidentForm?.cleanForm();
    }
    setTimeout(() =>  {
      this._modal.close();
      this.modalVisible = false;
    }, 100); 
  }

  onConfirmSave(type) {
    switch (type) {
      case this.incidentManagementTypes.Incidents:
        this._incidentForm.onConfirmSave();
        this.closeBySave = true;
        break;
      case this.incidentManagementTypes.Communications:
        this._communicationForm.onSave(this._communicationForm._formElement);
        this.closeBySave = true;
        break;
      case this.incidentManagementTypes.AssociateIncident:
        this._associateIncident.onSave();
        this.closeBySave = true;
        break;
      case this.incidentManagementTypes.IncidentFile:
        this._incidentFileForm.onSave(this._incidentFileForm._formElement);
        this.closeBySave = true;
        break;
      default:
        break;
    }
  }

  onSave(type, event) {
    switch (type) {
      case this.incidentManagementTypes.Incidents:
        this._incidentForm.onSave(this._incidentForm._formElement, event);
        this.closeBySave = true;
        break;
      default:
        break;
    }
  }

  setMenuList(event) {    
    if(!event){
      this.menuButtonList = [
        { label: 'Guardar y cerrar', value:2},
        { label: 'Guardar y cancelar', value:3}
      ]
    } else {
      this.menuButtonList = [
        { label: 'Guardar y cancelar', value:3}
      ];
    }
    this.cdRef.detectChanges();
  }

  onDisabledForm(event) {
    this.disabledForm = event;
    this.cdRef.detectChanges()
  }
}
